import React from 'react';
import { Bell } from 'lucide-react';

/**
 * 1. Header Component
 * Displays user info, branding, and notifications.
 */
interface HeaderProps {
  isLoggedIn: boolean;
  userName: string;
  onLogout: () => void;
}

const Header: React.FC<HeaderProps> = ({ isLoggedIn, userName, onLogout }) => (
    <header className="p-6 pb-4 flex justify-between items-start bg-gray-800 z-10">
        {isLoggedIn ? (
            <div>
                <div className='flex items-center space-x-2 mb-0.5'>
                    <p className="text-sm text-gray-400">Welcome back,</p>
                    <button
                        onClick={onLogout}
                        className="px-2 py-0.5 text-xs font-medium text-red-400 border border-red-700 bg-red-900/30 rounded-lg hover:bg-red-900 transition"
                    >
                        Logout
                    </button>
                </div>
                <h1 className="text-xl font-bold text-white">{userName}</h1>
            </div>
        ) : (
            <div>
                <h1 className="text-xl font-bold text-white mt-2">Book Appointment</h1>
                <p className="text-sm text-gray-400">with our best service provider</p>
            </div>
        )}

        <button
            aria-label="Notifications"
            className="p-3 relative rounded-full hover:bg-gray-700 transition"
        >
            <Bell className="w-6 h-6 text-gray-400" />
            <span className="absolute top-2 right-2 block h-2 w-2 rounded-full ring-2 ring-gray-800 bg-red-500"></span>
        </button>
    </header>
);

export default Header;
